import React, { useState } from 'react';

/**
 * GeneralPage component for Training module.
 * Displays general information or content for training.
 */
const DashboardPage: React.FC = () => {
    const [selectedHelpPage, setSelectedHelpPage] = useState("shortcuts");

    function getContent(name: string): JSX.Element {
        switch (name) {
            case "shortcuts":
                return <Shortcuts />
            case "dashboard":
                return <Dashboard />
            default:
                return <Shortcuts />
        }
    }

    return (
        <div className="flex flex-row w-full pt-4">
            <div className="flex flex-col min-w-[200px] mr-2">
                <ul className="text-center">
                    <li className={(selectedHelpPage == "shortcuts" ? "bg-table-subheader " : "bg-table-header ") + "rounded-tl-md p-2 bg-table-header hover:cursor-pointer "} onClick={() => setSelectedHelpPage("shortcuts")}>Keyboard Shortcuts</li>
                    <li className={(selectedHelpPage == "dashboard" ? "bg-table-subheader " : "bg-table-header ") + "rounded-bl-md p-2 bg-table-header hover:cursor-pointer "} onClick={() => setSelectedHelpPage("dashboard")}>Dashboard</li>
                </ul>
            </div>
            <div className="flex flex-col h-[800px] p-2 overflow-y-auto scrollbar">{getContent(selectedHelpPage)}</div>
        </div>
    );
};

export default DashboardPage;

const Shortcuts: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Keyboard Shortcuts</h1>
            <table className="table-auto border-collapse border border-slate-400">
                <thead>
                    <tr>
                        <th className="border border-slate-300 p-2">Shortcut</th>
                        <th className="border border-slate-300 p-2">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + B</td>
                        <td className="border border-slate-300 p-2">Hide / Show Sidebar</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + J</td>
                        <td className="border border-slate-300 p-2">Open the 'Jump' menu to navigate quickly</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

const Dashboard: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Dashboard</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/general/MultiProject_Dashboard.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        The Dashboard provides an overview of multiple projects, displaying key metrics and statuses at a glance.
                    </p>
                    <br />
                    <p>
                        You can choose which projects to display using the project selector at the top.
                    </p>
                    <br />
                    <p>
                        You can choose which Dashboard elements to display using the view selector at the top.
                    </p>
                    <br />
                    <p>
                        Every element on the Dashboard can be clicked and will display relevant information related to that item 
                        or navigate directly to the page in the relevant project to display the data behind the metric.
                    </p>
                    <br />
                    <p>
                        If you are not displaying all projects, you can click the "View All Projects" button to display all projects.
                    </p>
                </div>
            </div>
        </>
    );
}